import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/navbar/Navbar';
import styles from './Home.module.scss'
import data from '../data/db.json'

const Home = () => {

    const firstPost = data[0];
    const lastIndex = data.length - 1;
    const lastPost = data[lastIndex];

    return (
        <div className={styles.landing}>
             <p className={styles.alert}>As this project comes to an end, my new portfolio will be hosted: <a href="https://evanshaw.dev/">evanshaw.dev</a></p>
            <h1>Home</h1>
            <p>Hello! My name is Evan, and I'd like to welcome you to my quickly evolving little corner of the internet, 'The Evan Project.' It's an ongoing, rapidly evolving, and continuously refactored project that allows me to focus on pushing my limits, stepping out of my comfort zone, and developing the best me that I can be. As we move forward through the final days of 2023 and into 2024, this site will see massive updates and go through changes as I work on it daily. If you find yourself here and don't know why, this link is a great starting point:</p>

            <h3>Where we began:</h3>

            <Link to={`/post/${firstPost.id}`} className={styles.postLink}>
                <div className={styles.post}>
                    <p>{firstPost.date}:</p>
                    <p>{firstPost.title}</p>
                </div>
            </Link>

            <h3>Where we are at:</h3>

            <Link to={`/post/${lastPost.id}`} className={styles.postLink}>
                <div className={styles.post} >
                    <p>{lastPost.date}:</p>
                    <p>{lastPost.title}</p>
                </div>
            </Link>

        </div>
    )
}

export default Home;